import React, { useRef } from "react";
import { useTranslation } from "react-i18next";
import PropTypes from "prop-types";
import { showSuccessToast, showErrorToast } from "~/components/Toast";
import { CopyButton } from "./CopyButton";

export const CopySnippet = ({ codeContent, hideCopyButton }) => {
  const { t } = useTranslation();
  const preRef = useRef(null);

  const handleCopyCode = async () => {
    if (!preRef.current) {
      return;
    }

    let content = preRef.current.innerText;
    content = content.replace(/\n\n/g, "\n\u00A0\n");

    try {
      await navigator.clipboard.writeText(content);
      showSuccessToast(t("Code copied to clipboard"));
    } catch (error) {
      showErrorToast(t("Failed to copy code to clipboard"));
    }
  };

  return (
    <div className="tw-relative pre-copy-wrapper tw-group">
      <pre
        ref={preRef}
        className="tw-bg-theme-200 tw-text-theme-900 tw-rounded-md tw-px-4 tw-py-3 tw-overflow-x-auto tw-my-0"
      >
        <code>{codeContent}</code>
      </pre>
      {!hideCopyButton && (
        <CopyButton
          size="medium"
          onCopy={handleCopyCode}
          iconClassName="pre-copy-button tw-absolute tw-top-2 tw-right-2 tw-invisible group-hover:tw-visible"
        />
      )}
    </div>
  );
};

CopySnippet.propTypes = {
  codeContent: PropTypes.node,
  hideCopyButton: PropTypes.bool,
};

CopySnippet.defaultProps = {
  hideCopyButton: false,
};
